import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

interface MembroEquipe {
  nome: string;
  info?: string;
}

interface Equipe {
  titulo: string;
  subtitulo?: string;
  membros: MembroEquipe[];
}

@Component({
  selector: 'app-equipe',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './equipe.component.html',
  styleUrl: './equipe.component.scss'
})
export class EquipeComponent {
  equipes: Equipe[] = [
    {
      titulo: 'Concepção, análise de dados e testes',
      subtitulo: 'Laboratório de Dados Educacionais (UFG | UFPR | USP)',
      membros: [
        { nome: 'Adriana Dragone Silveira', info: 'coordenação / USP' },
        { nome: 'Gabriela Schneider', info: 'coordenação / UFPR' },
        { nome: 'Thiago Alves', info: 'coordenação / UFG' },
        { nome: 'Jaqueline Aparecida Cardoso', info: 'coordenação de testes e documentação' },
        { nome: 'Alessandra Biscaia de Andrade', info: 'pesquisa' },
        { nome: 'Alexia Furno Diniz', info: 'pesquisa' },
        { nome: 'Andrea Polena', info: 'pesquisa' },
        { nome: 'Raphael Demóstenes Cardozo', info: 'pesquisa' }
      ]
    },
    {
      titulo: 'Tecnologia da Informação',
      subtitulo: 'Fábrica de Software (FS/INF/UFG)',
      membros: [
        { nome: 'Leonardo Antônio Alves', info: 'coordenador' },
        { nome: 'Danillo Guimarães de Oliveira', info: 'líder técnico de Desenvolvimento' },
        { nome: 'Mariana Soller Ramada', info: 'gerente de projeto' },
        { nome: 'Murilo Lopes da Luz', info: 'arquiteto de Software' },
        { nome: 'Bruccy Mendes Sodre', info: 'desenvolvedor' },
        { nome: 'Gabriel Camilo Silva Oliveira', info: 'desenvolvedor' },
        { nome: 'Giancarlo Moraes de Sousa', info: 'desenvolvedor' },
        { nome: 'João Gabriel Tavares Félix Monteiro', info: 'desenvolvedor' },
        { nome: 'Karlla Loane Santos Lima', info: 'desenvolvedora' },
        { nome: 'Ramon Lopes da Silva', info: 'desenvolvedor' }
      ]
    },
    {
      titulo: 'Design',
      membros: [
        { nome: 'Giulia Morgan Riva' },
        { nome: 'Maria Fernanda Cardoso Gonçalves' }
      ]
    },
    {
      titulo: 'Ex-integrantes do Projeto',
      membros: [
        { nome: 'Profº. Dr. Marcos Sunye', info: 'C3SL/DINF/UFPR' },
        { nome: 'Profº. Dr. Marcos Didonet', info: 'C3SL/DINF/UFPR' },
        { nome: 'Arthur Henrique Canello Vilar', info: 'C3SL/UFPR' },
        { nome: 'Eduardo Mathias de Souza', info: 'C3SL/UFPR' },
        { nome: 'Fernando Gbur dos Santos', info: 'C3SL/UFPR' },
        { nome: 'Guiusepe Oneda Dal Pai', info: 'C3SL/UFPR' },
        { nome: 'Henrique Varella Ehrenfried', info: 'C3SL/UFPR' },
        { nome: 'Leon Augusto Okida Gonçalves', info: 'C3SL/UFPR' },
        { nome: 'Janaína Saldiva Kshesek', info: 'C3SL/UFPR' },
        { nome: 'Névisson Gonçalves Santos', info: 'Desenvolvedor frontend' },
        { nome: 'Roberto Pedro da Silva Júnior', info: 'Desenvolvedor frontend' },
        { nome: 'Sérgio Dias Borges', info: 'Desenvolvedor frontend' }
      ]
    }
  ];
}
